export function QBOSupportRetrieveRecordByIdCtrl ($scope, $uibModalInstance, workshopAPI, result, qbo_type) {

  $scope.type = qbo_type;
  $scope.result = result ? result : {};
}